import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const LensDestinationsTooltipContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    min-width: 270px;
    padding: ${Spacing.SM}px ${Spacing["1XS"]}px;

    color: ${Colors.WHITE};

    .sds-row-skeleton > div {
        background-color: ${Colors.Black.V50};
        background-image: linear-gradient(
            90deg,
            ${Colors.Black.V50} 25%,
            ${Colors.Black.V100} 37%,
            ${Colors.Black.V50} 63%
        );
    }

    /* override sds tooltip styles */
    .sds-row-skeleton,
    .sds-row-skeleton-row {
        margin: 0 !important;
    }
`;

export const LensDestinationRowContainer = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
    margin: 0 !important;
    padding: 4px 0;

    > div {
        /* override sds tooltip styles */
        margin: 0 !important;
    }

    &:not(:last-child) {
        margin-bottom: ${Spacing.XS}px;
    }
`;

export const LensDestinationText = styled.div<{ color?: string }>`
    flex: 1;
    ${Fonts.Paragraph.P300};

    /* override sds tooltip styles */
    margin: 0 !important;
    color: ${({ color = Colors.WHITE }) => color};
`;

export const zIndex = css`
    /* override sds tooltip styles */
    z-index: 200 !important;
`;
